import { useThemeStore, resolveMode } from '../theme/store';
import { themeRegistry, type RegisteredTheme } from '../theme/registry';
import type { ThemeMode } from '../theme/contract';

export interface UseThemeResult {
  themeId: string;
  mode: ThemeMode | 'system';
  /** The effective light/dark after resolving `'system'`. */
  resolvedMode: ThemeMode;
  themes: readonly RegisteredTheme[];
  setTheme: (id: string) => void;
  setMode: (mode: ThemeMode | 'system') => void;
  toggleMode: () => void;
}

/** Ergonomic accessor over the theme store for pickers and toggles. */
export function useTheme(): UseThemeResult {
  const themeId = useThemeStore((s) => s.themeId);
  const mode = useThemeStore((s) => s.mode);
  const setTheme = useThemeStore((s) => s.setTheme);
  const setMode = useThemeStore((s) => s.setMode);
  const resolvedMode = resolveMode(mode);

  return {
    themeId,
    mode,
    resolvedMode,
    themes: themeRegistry,
    setTheme,
    setMode,
    toggleMode: () => setMode(resolvedMode === 'dark' ? 'light' : 'dark'),
  };
}
